import { Button } from 'antd';
import { TFunction } from 'i18next';

export const AllColumnsHidden = ({
    t,
    onShowAll,
}: {
    t: TFunction;
    onShowAll: () => void;
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-20 text-center gap-4">
            <p className="text-M-24 text-textPrimary">
                {t('general.allColumnsHidden')}
            </p>
            <p className="text-R-16 text-neutral-400">
                {t('general.allColumnsHiddenMessage')}
            </p>
            <Button size="large" onClick={onShowAll} className="btn-primary">
                {t('buttons.showAllColumns')}
            </Button>
        </div>
    );
};
